import React, { useState } from "react";
import TagInputs from "./inputs/TagInputs";
import { useNavigate } from "react-router-dom";

const PasswordCreation = ({ prevStep, renderStepper }) => {
    const [password, setPassword] = useState("");

    const checks = {
        hasUppercase: /[A-Z]/.test(password),
        hasSpecialChar: /[$#!*()?]/.test(password),
        hasNumber: /\d/.test(password),
        hasLowercase: /[a-z]/.test(password),
    };
    const navigate = useNavigate();

    return (
        <div className="w-100">
            <div className="container flex-direction-v">
                {renderStepper()}
                <div className="container center-text col-6">
                    <img src="/SidebarLogo.png" alt="logo" />
                    <h2 className="m-t-20">Create Password</h2>
                    <TagInputs
                        label="Password"
                        type="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="password-checks m-b-20 m-t-20">
                        <label className={checks.hasUppercase ? "valid" : ""}>
                            Password must contain an uppercase letter
                            <input type="checkbox" checked={checks.hasUppercase} readOnly />
                        </label>
                        <label className={checks.hasSpecialChar ? "valid" : ""}>
                            Password must contain a special character ($#!*()?)
                            <input type="checkbox" checked={checks.hasSpecialChar} readOnly />
                        </label>
                        <label className={checks.hasNumber ? "valid" : ""}>
                            Password must contain at least one number
                            <input type="checkbox" checked={checks.hasNumber} readOnly />
                        </label>
                        <label className={checks.hasLowercase ? "valid" : ""}>
                            Password must contain a lowercase letter
                            <input type="checkbox" checked={checks.hasLowercase} readOnly />
                        </label>
                    </div>
                    <TagInputs label="Confirm Password" type="password" placeholder="Confirm your password" />
                    <button onClick={() => navigate("/community")} className="submit-btn m-t-20" disabled={!Object.values(checks).every(Boolean)}>Submit</button>
                    <button className="save-drafts m-t-20" onClick={prevStep}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default PasswordCreation;
